/**
 * @memberOf loavies.models.chat
 * @constructor
 */
export class TalkJsIncomingMessageModel {
  /**
   * @param {string} id
   * @param {string} transactionId TransactionId
   * @param {Object} [attachment]
   * @param {number} timestamp UnixMilliseconds
   * @param {Object} [custom]
   * @param {string} [origin]
   * @param {boolean} [read]
   * @param {string} [text]
   * @param {string} [type]
   * @param {string} [senderId]
   * @param {boolean} [isByMe]
   */
  constructor({
      id,
      transactionId,
      attachment,
      timestamp,
      custom,
      origin,
      read,
      text,
      type,
      senderId,
      isByMe,
    }) {

    /** @type {string} */
    this.id = id

    /** @type {string} */
    this.transactionId = transactionId

    /** @type {Object} */
    this.attachment = attachment

    /** @type {number} */
    this.timestamp = timestamp

    /** @type {Object} */
    this.custom = custom

    /** @type {string} */
    this.origin = origin

    /** @type {boolean} */
    this.read = read

    /** @type {string} */
    this.text = text

    /** @type {string} */
    this.type = type

    /** @type {string} */
    this.senderId = senderId

    /** @type {boolean} */
    this.isByMe = isByMe
  }
}
